import {
  Component,
  OnInit,
  OnDestroy,
  OnChanges,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  ILiquidacion,
  IPeriodo,
  IColumnsDataTable,
} from 'src/app/shared/Entities/entities';
import { Subscription, Observable } from 'rxjs';
import { PipeEnum } from 'src/app/shared/helpers/constants';
import * as moment from 'moment';
import { ProductService } from 'src/app/shared/services/product.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { MatDialog } from '@angular/material';
import { LiquidacionesModalComponent } from './liquidaciones-modal/liquidaciones-modal.component';
import { CurrencyPipe } from '@angular/common';
import { AppInsightsService } from 'src/app/shared/services/app-insights-service';
import { Event } from 'src/app/shared/enums/insights/event';

@Component({
  selector: 'app-tab-liquidaciones',
  templateUrl: './tab-liquidaciones.component.html',
  styleUrls: ['./tab-liquidaciones.component.sass'],
})
export class TabLiquidacionesComponent implements OnInit, OnDestroy, OnChanges {
  @Input() idPoliza: string;
  @Input() tipoSeguro: string;
  @Input() lineaNegocio: string;
  @Input() numPersona: string;
  @Input() tabActive: boolean;
  @Output() getPrintData$ = new EventEmitter();

  private currencyPipe: CurrencyPipe;

  mainData: ILiquidacion[];

  selectedPeriod: string;
  cardSelectedPeriod: string;

  data: ILiquidacion[];
  dataTable;
  periodos: IPeriodo[];
  error = false;
  loading = false;

  private subscriptions: Subscription[] = [];

  displayedColumns = [
    {
      ColumnDef: 'FechaLiquidacionUI',
      ColumnName: 'FECHA LIQUIDACIÓN',
      // Pipe: PipeEnum.datePipe,
    },
    {
      ColumnDef: 'TotalIngresos',
      ColumnName: 'PENSION BRUTA ($)',
      // Pipe: PipeEnum.currencyCLPipe,
    },
    {
      ColumnDef: 'LiquidoPagar',
      ColumnName: 'PENSION LIQUIDA ($)',
      // Pipe: PipeEnum.currencyCLPipe,
    },
    {
      ColumnDef: 'search',
      ColumnName: 'VER',
      Icon: true,
      IconAlign: 'mat-cell-right',
    },
  ] as IColumnsDataTable[];

  private screenSize$: Observable<string>;
  screenSize: string;

  constructor(
    private productSrv: ProductService,
    private commonSvc: CommonService,
    public modal: MatDialog,
    private appInsightsService: AppInsightsService
  ) {
    this.screenSize$ = this.commonSvc.screenSize$;

    this.screenSize$.subscribe(res => {
      this.screenSize = res;
    });
    this.currencyPipe = new CurrencyPipe('es-CL');
  }

  ngOnChanges() {
    this.sendPrintData();
  }

  sendPrintData() {
    if (this.tabActive) {
      this.getPrintData$.emit(this.print());
    }
  }

  ngOnInit() {
    const periodosSubscription = this.productSrv
      .getVitaliciaListPeriodoLiquidaciones(
        this.idPoliza,
        this.tipoSeguro,
        this.numPersona
      )
      .subscribe(
        data => {
          this.loading = true;
          this.error = false;
          this.periodos = data;
          this.selectedPeriod =
            this.periodos || this.periodos.length > 0
              ? this.periodos[0].Anno
              : '';
          const liquidacionesSubscription = this.productSrv
            .getVitaliciaListLiquidaciones(
              this.idPoliza,
              this.tipoSeguro,
              this.numPersona
            )
            .subscribe(
              res => {
                this.mainData = res;
                this.loading = false;
              },
              err => {
                this.loading = false;
                this.error = true;
              }
            );
          this.subscriptions.push(liquidacionesSubscription);
          this.loading = false;
        },
        err => {
          this.loading = false;
          this.error = true;
        }
      );
    this.subscriptions.push(periodosSubscription);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
  getLiquidaciones() {
    // this.data = this.mainData.filter(
    //   x =>
    //     moment(x.FechaLiquidacion, 'DD-MM-YYYY')
    //       .year()
    //       .toString() === this.selectedPeriod
    // );
    this.appInsightsService.trackEvent(Event.pidlBtnSearchLiquidation);
    this.data = this.mainData.filter(
      x =>
        moment(x.FechaLiquidacionUI, 'DD-MM-YYYY')
          .year()
          .toString() === this.selectedPeriod
    );
    this.dataTable = this.data;
    this.dataTable.forEach(x => {
      x.TotalIngresos = this.currencyPipe
        .transform(x.TotalIngresos, '$ ')
        .slice(0, -3);
      x.LiquidoPagar = this.currencyPipe
        .transform(x.LiquidoPagar, '$ ')
        .slice(0, -3);
    });
    this.cardSelectedPeriod = this.selectedPeriod;
    this.sendPrintData();
  }

  onIconClick(item) {
    this.appInsightsService.trackEvent(Event.pidlIcShowDetailLiquidation);
    const dlLiquidacionesSubs = this.productSrv
      .downloadVitaliciaLiquidaciones(
        this.idPoliza,
        this.tipoSeguro,
        this.numPersona,
        item.item.NumeroLiquidacion
      )
      .subscribe(
        res => {
          this.modal.open(LiquidacionesModalComponent, {
            data: {
              NumPoliza: this.idPoliza,
              ...res,
            },
            // height: '712px',
            width: '49.0625rem',
            // maxWidth: '100vw', maxHeight: '100vh',
            disableClose: false,
            // panelClass: 'liquidaciones-modal',
          });
        },
        err => alert('Se produjo un error. Intente de nuevo.')
      );

    this.subscriptions.push(dlLiquidacionesSubs);

    /* this.personService.getDatosBeneficiarios(this.idPoliza).subscribe(data => {
      const dialogRef = this.modal.open(BeneficiarioModalComponent, {
        data: {
          Nombre: item.item.Nombre,
          ...data,
        },
        height: '20.15rem',
        width: '49.0625rem',
        disableClose: true,
        panelClass: 'beneficiario-dialog',
      });
    }); */
  }

  /* onIconClick(item) {
    const dlLiquidacionesSubs = this.productSrv
      .downloadVitaliciaLiquidaciones(
        this.idPoliza,
        this.tipoSeguro,
        this.numPersona,
        item.item.NumeroLiquidacion
      )
      .subscribe(
        res => {
          const data = [
            {
              type: 'logo',
              content: {
                halign: 'right',
              },
            },
            {
              type: 'title',
              content: {
                text: 'LIQUIDACIONES DE PENSIONES',
                halign: 'left',
              },
            },
            {
              type: 'table',
              width: 60,
              content: {
                size: {
                  columns: [50, 50],
                },
                table: [
                  [
                    {
                      value: 'Numero Liquidacion',
                      halign: 'left',
                    },
                    { value: res.NumeroLiquidacion, halign: 'right' },
                  ],
                  [
                    { value: 'Renta', halign: 'left' },
                    { value: res.Renta, halign: 'right' },
                  ],
                  [
                    { value: 'Valor UF', halign: 'left' },
                    { value: res.ValorUF, halign: 'right' },
                  ],
                  [
                    { value: 'Mes Proceso', halign: 'left' },
                    { value: res.MesProceso, halign: 'right' },
                  ],
                  [
                    { value: 'Fecha Pago', halign: 'left' },
                    { value: res.FechaPagoUI, halign: 'right' },
                  ],
                  [
                    { value: 'Proximo Pago', halign: 'left' },
                    { value: res.ProximoPagoUI, halign: 'right' },
                  ],
                  [
                    { value: 'Nombre Benefeciario', halign: 'left' },
                    { value: res.NombreBeneficiario, halign: 'right' },
                  ],
                  [
                    { value: 'Rut Benefeciario', halign: 'left' },
                    { value: res.RutBeneficiario, halign: 'right' },
                  ],
                  [
                    { value: 'Parentesco', halign: 'left' },
                    { value: res.Parentesco, halign: 'right' },
                  ],
                  [
                    { value: 'Isapre', halign: 'left' },
                    { value: res.Isapre, halign: 'right' },
                  ],
                  [
                    { value: 'Numero Oficio', halign: 'left' },
                    { value: res.NumeroOficio, halign: 'right' },
                  ],
                  [
                    { value: 'Cheque', halign: 'left' },
                    { value: res.Cheque, halign: 'right' },
                  ],
                  [
                    { value: 'Direccion Pago', halign: 'left' },
                    { value: res.DireccionPago, halign: 'right' },
                  ],
                  [
                    { value: 'Comuna Pago', halign: 'left' },
                    { value: res.ComunaPago, halign: 'right' },
                  ],
                  [
                    { value: 'Ciudad Pago', halign: 'left' },
                    { value: res.CiudadPago, halign: 'right' },
                  ],
                  [
                    { value: 'Via Pago', halign: 'left' },
                    { value: res.ViaPago, halign: 'right' },
                  ],
                  [
                    { value: 'Banco', halign: 'left' },
                    { value: res.Banco, halign: 'right' },
                  ],
                  [
                    { value: 'Tipo Cuenta', halign: 'left' },
                    { value: res.TipoCuenta, halign: 'right' },
                  ],
                  [
                    { value: 'Oficina', halign: 'left' },
                    { value: res.Oficina, halign: 'right' },
                  ],
                  [
                    { value: 'Nombre Tutor', halign: 'left' },
                    { value: res.NombreTutor, halign: 'right' },
                  ],
                  [
                    { value: 'Rut Tutor', halign: 'left' },
                    { value: res.RutTutor, halign: 'right' },
                  ],
                  [
                    { value: 'Tipo Pension', halign: 'left' },
                    { value: res.TipoPension, halign: 'right' },
                  ],
                  [
                    { value: 'Imponible', halign: 'left' },
                    { value: res.Imponible, halign: 'right' },
                  ],
                  [
                    { value: 'Tributable', halign: 'left' },
                    { value: res.Tributable, halign: 'right' },
                  ],
                  [
                    { value: 'Liquido', halign: 'left' },
                    { value: res.Liquido, halign: 'right' },
                  ],
                  [
                    { value: 'NumeroCuenta', halign: 'left' },
                    { value: res.NumeroCuenta, halign: 'right' },
                  ],
                  [
                    { value: 'Haberes', halign: 'left' },
                    { value: res.Haberes, halign: 'right' },
                  ],
                  [
                    { value: 'Descuentos', halign: 'left' },
                    { value: res.Descuentos, halign: 'right' },
                  ],
                ],
              },
            },
          ];

          preparePrint(this.router, data);

          // const pdf = `data:application/octet-stream;charset=utf-16le;base64,${encodeURIComponent(
          //   data
          // )}`;
          // const a = document.createElement('a');
          // document.body.appendChild(a);
          // a.setAttribute('style', 'display: none');
          // a.href = pdf;
          // a.download = `liquidacion_${item.item.NumeroLiquidacion}.pdf`;
          // a.click();
          // window.URL.revokeObjectURL(pdf);
          // a.remove(); // remove the element
        },
        err => alert('Se produjo un error. Intente de nuevo.')
      );

    this.subscriptions.push(dlLiquidacionesSubs);
  } */

  print() {
    if (this.error || !this.data) {
      return null;
    }

    const data = [];
    this.data.forEach(d =>
      data.push([
        {
          value: d.FechaLiquidacionUI,
        },
        {
          value: d.TotalIngresos,
          halign: 'right',
        },
        {
          value: d.LiquidoPagar,
          halign: 'right',
        },
      ])
    );
    return [
      {
        type: 'logo',
        content: {
          halign: 'right',
        },
      },
      {
        type: 'table',
        width: 60,
        content: {
          size: {
            columns: [40, 30, 30],
          },
          table: [
            [
              {
                value: `LIQUIDACIONES DE PENSIONES AÑO ${this.selectedPeriod}`,
                type: 'header',
                colspan: 3,
              },
            ],
            [
              { value: 'FECHA LIQUIDACION', type: 'header' },
              { value: 'PENSION BRUTA ($)', type: 'header' },
              { value: 'PENSION LIQUIDA ($)', type: 'header' },
            ],
            ...data,
          ],
        },
      },
    ];
  }

  expandChange() {
    this.appInsightsService.trackEvent(Event.pidlAccShowLiquidation);
  }
}
